import React from 'react';
import Video from './video';
import Specification from './specification';
import Details from './details';

const About = () => {
	return (
		<section id='about'>
			<Video />
			<Specification />
			<Details />
		</section>
	);
};

export default About;
